export default __webpack_public_path__ + "static/GooglePlay-63fb5c12a043c742448f07658ea64881.png";